import { Component, input, viewChild } from '@angular/core';
import { ISpeaker } from '../../icons/i-speaker/i-speaker';
import { AudioPlayer } from '../../utils/audio.utils';
import { RidAudioBubble } from '../rid-audio-bubble/rid-audio-bubble';

@Component({
  selector: 'rid-audio-button',
  imports: [ISpeaker, RidAudioBubble],
  templateUrl: './rid-audio-button.html',
  host: {
    class: 'block place-items-center',
  },
})
export class RidAudioButton {
  src = input.required<string>();
  size = input<'SMALL' | 'LARGE'>('LARGE');

  audioBubble = viewChild.required<RidAudioBubble>('audioBubble');

  public async play() {
    this.audioBubble().play();
    await AudioPlayer.play(this.src());
  }
}
